import React from 'react';
import Export from '../download/Export';
import styles from './ResultSignup.module.css';
import { ReactComponent as BlurGraph } from '../../assets/images/blur-graph.svg';
import { ReactComponent as BlurGraphMobile } from '../../assets/images/blur-graph-mobile.svg';
import SignIn from '../auth/SignIn';

const butterfly = require('../../assets/icons/butterfly.svg').default;
const trail = require('../../assets/images/butterfly-trail.svg').default;

export default function ResultSignup() {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.titleContainer}>
        <Export />
      </div>
      <div className={styles.imgContainer}>
        <BlurGraphMobile className={styles.mobileImage} />
        <BlurGraph className={styles.desktopImage} width="100%" height="100%" viewBox="0 0 585 460" />
        <div className={styles.modal}>
          <div className={styles.modalBar}>
            <img src={trail} alt="" />
            <img src={butterfly} alt="" />
          </div>
          <SignIn />
        </div>
      </div>
    </div>
  );
}
